import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {usePulsoidClient} from '../../../PulsoidClient';
import css from './ReportsV2Statistics.module.scss';
import {ReportStats} from '../../../types/Api/Reports';
import {IconLightning} from '../../../system/icons/IconLightning';
import {IconHeart} from '../../../system/icons/IconHeart';
import {IconClock} from '../../../system/icons/IconClock';
import {IconFire} from '../../../system/icons/IconFire';
import {StatisticsItem} from '../ReportsV2StatisticsItem/ReportsV2StatisticsItem';

const calculatePercantage = (current = 0, prev = 0) => {
  if (current === 0 && prev === 0) {
    return 0;
  }

  if (current === 0) {
    return -100;
  }

  if (prev === 0) {
    return 100;
  }

  return Math.round(((current - prev) / prev) * 100);
};

type Percantage = {
  max: number;
  avg: number;
  calories: number;
  hours: number;
};

export const ReportsV2Statistics = ({from, to}) => {
  const pulsoidClient = usePulsoidClient();
  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState<ReportStats | null>();
  const [percantage, setPercantage] = useState<Percantage>();

  const fetchStatistics = async () => {
    setStatistics(null);
    setLoading(true);
    const diff = moment(to).diff(from);
    const prevFrom = moment(from).subtract(diff, 'ms').toISOString();

    const [statisticsRes, prevStatisticsRes] = await Promise.all([
      pulsoidClient.getStatistics(from, to),
      pulsoidClient.getStatistics(prevFrom, from),
    ]);

    setStatistics(statisticsRes);
    setPercantage({
      max: calculatePercantage(statisticsRes?.max, prevStatisticsRes?.max),
      avg: calculatePercantage(statisticsRes?.avg, prevStatisticsRes?.avg),
      calories: calculatePercantage(
        statisticsRes?.calories,
        prevStatisticsRes?.calories
      ),
      hours: calculatePercantage(
        statisticsRes?.hours,
        prevStatisticsRes?.hours
      ),
    });

    setLoading(false);
  };

  useEffect(() => {
    fetchStatistics();
  }, [from, to]);

  return (
    <div className={css.statistics}>
      <StatisticsItem
        percantage={percantage?.max}
        value={statistics?.max}
        loading={loading}
        title="Max heart rate"
        titleIcon={<IconLightning />}
        valueSubText="BPM"
        listView
      />
      <StatisticsItem
        percantage={percantage?.avg}
        value={statistics?.avg}
        loading={loading}
        title="Average heart rate"
        titleIcon={<IconHeart />}
        valueSubText="BPM"
        listView
      />
      <StatisticsItem
        percantage={percantage?.calories}
        value={statistics?.calories}
        loading={loading}
        titleIcon={<IconFire />}
        title="Calories burned"
        valueSubText="KCAL"
        listView
      />
      <StatisticsItem
        percantage={percantage?.hours}
        value={statistics?.hours}
        loading={loading}
        titleIcon={<IconClock />}
        title="Hours streamed"
        valueSubText="Hours"
        listView
      />
    </div>
  );
};
